import { render, staticRenderFns } from "./customer-referral-invitations.vue?vue&type=template&id=a786d100&scoped=true"
import script from "./customer-referral-invitations.component.js?vue&type=script&lang=js&external"
export * from "./customer-referral-invitations.component.js?vue&type=script&lang=js&external"
import style0 from "./customer-referral-invitations.vue?vue&type=style&index=0&id=a786d100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a786d100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VSpacer})
